export enum AccessLevel {
    SE4Administrator = 100,
    OrgAdministrator = 200,
    User = 300,
    ReadOnly = 400
}